import { env } from './envvar';
export const GCP_PROJECT_ID = "puldev";
export const FIREBASE_PROJECT_ID = "fbads-vm";
export const VM_ZONE = "us-west4-b";
export const ENV = env
const dev = ENV == 'dev'
export const PROD_API_URL = 'https://asia-east2-fbads-vm.cloudfunctions.net/api'
export const DEV_API_URL = 'http://localhost:5001/fbads-vm/asia-east2/api'
export const API_URL = dev ? DEV_API_URL : PROD_API_URL
export const PROD_WEB_URL = 'https://fbads-vm.web.app'
export const DEV_WEB_URL = 'http://localhost:3000'
export const WEB_URL = dev ? DEV_API_URL : PROD_API_URL
export const GLITCH_URL = "https://fbads-vm-glide.glitch.me"
export const SUPPORT_EMAIL = "support@lightpc.in"